var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "login-div" } },
    [
      _c("h1", { staticClass: "page-title mt-2" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("registerTitle")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 small-content" },
        [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$t("register.Step") +
                  " " +
                  _vm.stepSignUp +
                  "/" +
                  _vm.maxStepSignUp
              )
            )
          ]),
          _vm._v(" "),
          _c("b-progress", {
            staticClass: "custom-progress-bar",
            attrs: {
              max: _vm.maxStepSignUp,
              value: _vm.stepSignUp,
              height: "1em",
              variant: "primary"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "content mt-4" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("registerSubtitle")) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.stepSignUp === 1
        ? _c(
            "form",
            {
              staticClass: "mt-4",
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.nextStep.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.form.username.invalidFeedback,
                    label: _vm.$t("loginFirstCredential"),
                    "label-for": "username-input"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "username-input",
                      state: _vm.form.username.state,
                      required: "",
                      type: "email"
                    },
                    on: {
                      change: function($event) {
                        return _vm.removeInvalidFeedback("username")
                      }
                    },
                    model: {
                      value: _vm.form.username.value,
                      callback: function($$v) {
                        _vm.$set(_vm.form.username, "value", $$v)
                      },
                      expression: "form.username.value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("loginSecondCredential"),
                    "label-for": "password-input"
                  }
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        staticClass: "form-input-with-right-append-inside",
                        attrs: {
                          id: "password-input",
                          state: _vm.form.password.state,
                          type: _vm.showPassword ? "text" : "password",
                          autocomplete: "off",
                          required: ""
                        },
                        model: {
                          value: _vm.form.password.value,
                          callback: function($$v) {
                            _vm.$set(_vm.form.password, "value", $$v)
                          },
                          expression: "form.password.value"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-input-group-append", [
                        _c(
                          "div",
                          {
                            staticClass: "cursor-pointer custom-eye",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.togglePassword.apply(null, arguments)
                              }
                            }
                          },
                          [
                            !_vm.showPassword
                              ? _c("i", {
                                  staticClass: "ph-custom ph-eye-fill"
                                })
                              : _c("i", {
                                  staticClass: "ph-custom ph-eye-slash-fill"
                                })
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.form.password.state
                    ? _c("span", { staticClass: "main-red-color" }, [
                        _vm._v(
                          " " + _vm._s(_vm.form.password.invalidFeedback) + " "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("signup.profile"),
                    "label-for": "password-input"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mr-5",
                          attrs: { value: "individual" },
                          model: {
                            value: _vm.selectedProfile,
                            callback: function($$v) {
                              _vm.selectedProfile = $$v
                            },
                            expression: "selectedProfile"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("signup.individual")) + "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "ml-5",
                          attrs: { value: "professional" },
                          model: {
                            value: _vm.selectedProfile,
                            callback: function($$v) {
                              _vm.selectedProfile = $$v
                            },
                            expression: "selectedProfile"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("signup.professional")) + "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.form.reason.invalidFeedback,
                    label: _vm.$t("Register.reason"),
                    state: _vm.form.reason.state,
                    "label-for": "reason-input"
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        id: "reason-input",
                        state: _vm.form.reason.state,
                        required: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.removeInvalidFeedback("reason")
                        }
                      },
                      model: {
                        value: _vm.form.reason.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.reason, "value", $$v)
                        },
                        expression: "form.reason.value"
                      }
                    },
                    _vm._l(_vm.reasons, function(reason) {
                      return _c(
                        "option",
                        {
                          key: reason.value,
                          domProps: { value: reason.value }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(reason.text) + "\n        "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "mt-5 d-flex justify-content-center flex-column align-items-center"
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-block",
                      attrs: { type: "submit", variant: "primary" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Next")))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3 d-flex justify-content-center" },
                    [
                      _c("span", { staticClass: "content" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("Login.goToLogin")) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "ml-1 signup-link",
                          on: { click: _vm.showLoginView }
                        },
                        [_vm._v(_vm._s(_vm.$t("Login")))]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.stepSignUp === 2
        ? _c(
            "form",
            {
              staticClass: "mt-4",
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.nextStep.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "small-text",
                        attrs: {
                          "invalid-feedback": _vm.form.lastname.invalidFeedback,
                          label: _vm.$t("user.Lastname"),
                          "label-for": "lastname-input"
                        }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "lastname-input",
                            state: _vm.form.lastname.state,
                            required: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.removeInvalidFeedback("lastname")
                            }
                          },
                          model: {
                            value: _vm.form.lastname.value,
                            callback: function($$v) {
                              _vm.$set(_vm.form.lastname, "value", $$v)
                            },
                            expression: "form.lastname.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "small-text",
                        attrs: {
                          "invalid-feedback":
                            _vm.form.firstname.invalidFeedback,
                          label: _vm.$t("user.Firstname"),
                          "label-for": "firstname-input"
                        }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "firstname-input",
                            state: _vm.form.firstname.state,
                            required: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.removeInvalidFeedback("firstname")
                            }
                          },
                          model: {
                            value: _vm.form.firstname.value,
                            callback: function($$v) {
                              _vm.$set(_vm.form.firstname, "value", $$v)
                            },
                            expression: "form.firstname.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("date-field", {
                      class: "small-text",
                      attrs: {
                        "date-name": _vm.$t("user.Birthday"),
                        "init-value": _vm.form.birthday.value,
                        "invalid-feedback": _vm.form.birthday.invalidFeedback,
                        "is-required": true,
                        "min-date": _vm.minAge(),
                        mode: "date",
                        state: _vm.form.birthday.state
                      },
                      on: {
                        change: function($event) {
                          return _vm.removeInvalidFeedback("birthday")
                        },
                        dateInfos: _vm.handleDate
                      }
                    }),
                    _vm._v(" "),
                    _vm.form.birthday.state === false
                      ? _c(
                          "b-form-invalid-feedback",
                          { staticClass: "d-flex mb-2" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.form.birthday.invalidFeedback)
                              ) + "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center custom-register-card"
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("Register.not.show.other.data")))
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-5 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-50 mr-2",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.prevStep.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-left-bold mr-1 align-self-center"
                          }),
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Previous")))]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-50",
                      attrs: { type: "submit", variant: "primary" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Next")))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.stepSignUp === 3
        ? _c(
            "form",
            {
              staticClass: "mt-4",
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.form.phoneNumber.invalidFeedback,
                    label: _vm.$t("user.PhoneNumber"),
                    state: _vm.form.phoneNumber.state,
                    "label-for": "phoneNumber-input"
                  }
                },
                [
                  _c("vue-phone-number-input", {
                    attrs: {
                      id: "phone-input",
                      dark: true,
                      error: _vm.form.phoneNumber.error,
                      placeholder: _vm.$t("user.phoneNumber"),
                      "dark-color": "#303030",
                      required: ""
                    },
                    on: { update: _vm.checkPhone },
                    model: {
                      value: _vm.form.phoneNumber.inputValue,
                      callback: function($$v) {
                        _vm.$set(_vm.form.phoneNumber, "inputValue", $$v)
                      },
                      expression: "form.phoneNumber.inputValue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.countryCode === "FR"
                ? _c(
                    "b-form-group",
                    {
                      staticClass: "small-text mb-4",
                      attrs: {
                        "invalid-feedback": _vm.form.department.invalidFeedback,
                        label: _vm.$t("user.Department"),
                        state: _vm.form.department.state,
                        "label-for": "department-input"
                      }
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          attrs: {
                            id: "department-input",
                            state: _vm.form.department.state
                          },
                          model: {
                            value: _vm.form.department.value,
                            callback: function($$v) {
                              _vm.$set(_vm.form.department, "value", $$v)
                            },
                            expression: "form.department.value"
                          }
                        },
                        _vm._l(_vm.departments, function(department) {
                          return _c(
                            "option",
                            { domProps: { value: department.serverId } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(department.name) +
                                  "\n        "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    "invalid-feedback": _vm.form.acceptedTerms.invalidFeedback,
                    state: _vm.form.acceptedTerms.state
                  }
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { id: "cgv-input", required: "" },
                      on: {
                        change: function($event) {
                          return _vm.removeInvalidFeedback("acceptedTerms")
                        }
                      },
                      model: {
                        value: _vm.form.acceptedTerms.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.acceptedTerms, "value", $$v)
                        },
                        expression: "form.acceptedTerms.value"
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("Register.Cgv")) }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-5 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-50 mr-2",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.prevStep.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-left-bold mr-1 align-self-center"
                          }),
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Previous")))]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-50",
                      attrs: { type: "submit", variant: "primary" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Next")))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("signup-professional-modal", {
        attrs: {
          redirectConnexionUrl: _vm.redirectProfessionalUrl,
          username: _vm.username
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", {
        staticClass: "ph-bold ph-question-bold",
        staticStyle: { "font-size": "1.5rem" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ff319a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff319a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/SignUpComponent.vue
// module id = 58+Z
// module chunks = 0